import {isEmpty} from "./isEmpty";

const textTransform = () => {
    const capitalizeFirstLetter = (str:any) => {

        if(isEmpty(str)) return ;
        return str?.slice(0, 1)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    }

    return { 
        capitalizeFirstLetter:capitalizeFirstLetter
    }
}

export { textTransform };
